module.exports = require("./../../_gen/starling/events/Event");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/events/Event.js
// module id = 180
// module chunks = 0